import {PROVIDER_FLAGS} from '@Constants/index.constants.js';

// One state per path: the v2 provider flag decides which component renders. lazyLoad
// resolves the flag before importing, to pull only the chunk that will actually render,
// and shares that lookup with the providerFlags resolve so the two cannot disagree.
// getPresentationFlags picks the private or public flag endpoint from the state itself,
// which is why print.private and print.public can share this config.
const commonConfig = {
	title: 'Print Proposal',
	params: {
		consultationId: null,
		proposalId: null,
		customerToken: null,
		serviceProviderId: null,
		showBack: null,
		origin: null,
	},
	templateProvider: [
		'providerFlags',
		providerFlags =>
			providerFlags?.[PROVIDER_FLAGS.PRESENTATION_V2]
				? '<print-proposal-v2 provider-flags="$resolve.providerFlags"></print-proposal-v2>'
				: '<print-proposal provider-flags="$resolve.providerFlags"></print-proposal>',
	],
	lazyLoad: $transition$ => {
		const $ocLazyLoad = $transition$.injector().get('$ocLazyLoad');
		const $log = $transition$.injector().get('$log');
		const RoutesSvc = $transition$.injector().get('RoutesResolveSvc');
		return (
			RoutesSvc.getPresentationFlags({trans: $transition$})
				// a failed lookup imports the production page; the providerFlags resolve below
				// reports the failure, so it is not swallowed here
				.catch(() => ({}))
				.then(flags =>
					flags?.[PROVIDER_FLAGS.PRESENTATION_V2]
						? import(
								/* webpackChunkName: "printProposalV2Mod" */
								'@Containers/print-proposal-page/print-proposal-v2.cmp.js'
							)
						: import(
								/* webpackChunkName: "printProposalPageMod" */
								'@Containers/print-proposal-page/print-proposal.cmp.js'
							)
				)
				.then(res => $ocLazyLoad.load({name: res.default}))
				.catch(err => $log.error(err))
		);
	},
	resolve: [
		{
			token: 'providerFlags',
			policy: {when: 'LAZY'},
			deps: ['RoutesResolveSvc', '$transition$'],
			resolveFn: (RoutesSvc, trans) => RoutesSvc.getPresentationFlags({trans}),
		},
	],
};

export const PrintPrivateState = {
	url: '/private/:consultationId/:proposalId?customerToken?serviceProviderId?showBack?origin',
	...commonConfig,
};

export const PrintPublicState = {
	url: '/public/:consultationId/:proposalId?customerToken?serviceProviderId?showBack?origin',
	...commonConfig,
};
